export function buildQueryMatch(property: string, term: any): any {
  return {match: {[property]: term}};
}

export function buildQueryTermEqual(property: string, term: any): any {
  return {term: {[property]: term}};
}

export function buildQueryTermsEqual(property: string, terms: any[]): any {
  return {terms: {[property]: terms}};
}

export function buildQueryRange(property: string, from: any, to: any): any {
  return {range: {[property]: {gte: from, lte: to}}};
}

export function buildQueryGreaterEqual(property: string, from: any): any {
  return {range: {[property]: {gte: from}}};
}

export function buildQueryGreater(property: string, from: any): any {
  return {range: {[property]: {gt: from}}};
}

export function buildQueryLessEqual(property: string, to: any): any {
  return {range: {[property]: {lte: to}}};
}

export function buildQueryLess(property: string, to: any): any {
  return {range: {[property]: {lt: to}}};
}

export function buildQueryRegex(property: string, regex: string): any {
  return {regexp: {[property]: {value: regex}}};
}

export function buildNestedQuery(parsedProperty: any, nestedPath: string): any {
  return {nested: {path: nestedPath, query: {bool: {must: [parsedProperty]}}}};
}

export function buildQueryAstroCircle(property: string, ra: number, dec: number, radius: number): any {
  return {astrofilt: {[property]: {shape: {type: 'circle', coordinates: [ra, dec], radius: radius / 60}}}};
}

export function buildAstroFiltQuery(property: string, polygon: string): any {
  return {astrofilt: {[property]: {shape: {type: 'shape', 'stc-s': polygon}}}};
}
